import React, { useEffect, useState } from 'react';
import { Typography, Button } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import BlueEarthTitleBar from '../../micro/BlueEarthTitleBar/BlueEarthTitleBar';
import HomeNavBar from '../../micro/HomeNavBar/HomeNavBar';
import { BASE_URL, IMAGE_PATHS } from '../../../constants/paths.constants';
import HomeFooter from '../../micro/HomeFooter/HomeFooter';
import VerificationModal from '../../micro/VerificationModal/VerificationModal';
// import RequestAccessModal from '../../micro/RequestAccessModal/RequestAccessModal';
import { blue, mediumGrey } from '../../../app/theme';
import AppState from '../../../models/redux/state/app.state';
import { setSeenHCPLocal } from '../../../redux/actions/auth/auth.actions';
import history from '../../../services/browserHistory';

const useStyles = makeStyles((theme: Theme) => ({
  images: {
    display: 'block',
    width: '100%',
  },
  welcomeBlock: {
    paddingLeft: 65,
    paddingRight: 75,
  },
  welcomeText: {
    fontSize: 40,
    paddingTop: 24,
    paddingBottom: 26,
    color: theme.palette.secondary.main,
  },
  bodyText: {
    fontSize: 20,
    lineHeight: 1.3,
    color: blue,
    fontWeight: 600,
  },
  bulletText: {
    color: mediumGrey,
  },
  requestButtonArea: {
    paddingTop: 24,
    paddingLeft: 65,
    paddingBottom: 32,
  },
  newText: {
    display: 'inline-block',
    color: blue,
    fontWeight: 'bold',
    fontSize: 20,
  },
  rquestAccessText: {
    display: 'inline-block',
    fontSize: 20,
  },
  requestButton: {
    backgroundColor: theme.palette.secondary.main,
    width: 149,
    color: 'white',
    borderRadius: 24,
  },
  list: {
    listStyle: 'none',
    paddingLeft: 20,
    margin: '20px 0',
    '& > li': {
      margin: '7px 0',
      color: mediumGrey,
      fontSize: 18,
    },
    '& > li::before': {
      content: '"\u2022"',
      fontWeight: 'bold',
      color: theme.palette.secondary.main,
      paddingRight: 10,
    },
  },
}));

const LandingPage = (): JSX.Element => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const hasSeenHCP = useSelector((state: AppState) => state.auth.hasSeenHCP);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
  const [isRequestModalOpen, setIsRequesstModalOpen] = useState<boolean>(false);

  useEffect(() => {
    setIsModalOpen(!hasSeenHCP);
  }, [hasSeenHCP]);

  const handleAccessModalOpen = (isOpen: boolean) => {
    if (!isOpen) {
      dispatch(setSeenHCPLocal(true));
    }
  };

  // const handleRequestModalOpen = (isOpen: boolean) => {
  //   setIsRequesstModalOpen(isOpen);
  // };

  const handleRegisterRedirect = () => {
    history.push('/user-registration');
  };

  return (
    <>
      <HomeNavBar />
      <BlueEarthTitleBar />
      <img
        className={classes.images}
        src={`${BASE_URL}${IMAGE_PATHS.TECH_AND_PATIENT.path}`}
        alt={`${IMAGE_PATHS.TECH_AND_PATIENT.alt}`}
      />

      {/* 3 color bar */}
      <img
        className={classes.images}
        src={`${BASE_URL}${IMAGE_PATHS.TRICOLOR_BAR.path}`}
        alt={`${IMAGE_PATHS.TRICOLOR_BAR.alt}`}
      />

      {/* Welcome Text block */}
      <div className={classes.welcomeBlock}>
        <Typography className={classes.welcomeText}>Welcome to Blue Earth Diagnostics Training</Typography>
        <Typography paragraph className={classes.bodyText}>
          This platform contains training and patient case studies, along with additional resources, which are uniquely
          tailored to nuclear medicine physicians, technologists, and professionals in related fields. Our team is
          committed to improving the lives of patients through innovative imaging solutions that optimize cancer care.
        </Typography>
        <Typography paragraph className={classes.bodyText}>
          For the best user experience, all training is optimized for desktop use only.
        </Typography>
        <Typography className={classes.bodyText}>
          The platform is designed to offer virtual on-demand training for:
        </Typography>
        <ul className={classes.list}>
          <li>
            <em>
              <b>Nuclear medicine physicians, radiologists, oncologists, and urologists</b>
            </em>
          </li>
          <li>
            <em>
              <b>Nuclear medicine technologists</b>
            </em>
          </li>
          <li>
            <em>
              <b>Nuclear medicine professionals and professionals in related fields</b>
            </em>
          </li>
        </ul>
        <span>
          <Typography className={classes.newText}>New to the platform?&nbsp;</Typography>
          <Typography className={classes.rquestAccessText}>
          Register with your full name and institution to obtain your login credentials.
          </Typography>
        </span>
      </div>
      <div className={classes.requestButtonArea}>
        <Button
          color="secondary"
          variant="contained"
          className={classes.requestButton}
          onClick={handleRegisterRedirect}
        >
          REGISTER
        </Button>
      </div>
      {/* Light Blue footer */}
      <HomeFooter />
      <VerificationModal isOpen={isModalOpen} handleModalOpen={(isOpen: boolean) => handleAccessModalOpen(isOpen)} />
      {/* <RequestAccessModal
        isOpen={isRequestModalOpen}
        handleModalOpen={(isOpen: boolean) => handleRequestModalOpen(isOpen)}
      /> */}
    </>
  );
};

export default LandingPage;
